import React from 'react';
import ComplexServiceDetails from './Components/ComplexServiceDetails';

const ComplexServiceDetailsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <ComplexServiceDetails />
      </div>
    </div>
  );
};

export default ComplexServiceDetailsPage;
